export const formatTimestamp = (timestamp) => {
    return new Date(timestamp * 1000).toLocaleString('en-US');
}
